import Vue from "vue";
import Vuex from "vuex";
import api_fabric from "../api/ApiFabric";

import global from "./global";
import server_error from "./server_error";
import billing from "./billing";
import wallets from "./wallets";
import missions from "./missions";
import shop from "./shop";
import stats from "./stats";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    server_error,
    billing,
    wallets,
    missions,
    shop,
    stats,
  },
});

const error_handler = function(data) {
  store.commit("server_error/writeServerErrorData", data);
};

api_fabric.registerErrorHandler(error_handler);

export default store;
